import { ArcadePageHeader, spacing, Stack } from '@cash-design-system/react'
import { DisclosureBlocker } from '@cash-web/protos/squareup/franklin/blockers/disclosure_blocker.pb'

import DisclaimerIcon from '../components/DisclaimerIcon/DisclaimerIcon'
import { disclaimerTextTokenizer } from '../components/DisclaimerTextTokenizer/DisclaimerTextTokenizer'
import LineItems from '../components/LineItems/LineItems'
import ShippingAddress, { AddressInformation } from '../components/ShippingAddress/ShippingAddress'

export const DynamicDisclosureLayout = ({
  disclosure,
  shippingAddress,
}: {
  disclosure: DisclosureBlocker
  shippingAddress?: AddressInformation
}) => {
  const descriptionText = disclaimerTextTokenizer([disclosure?.description_text])
  const footerText = disclaimerTextTokenizer([disclosure?.footer_text])

  return (
    <Stack space={spacing.xl}>
      <Stack space={spacing.m}>
        <DisclaimerIcon />
        <ArcadePageHeader title={disclosure?.headline_text ?? ''} titleElement="h1" />
      </Stack>
      {shippingAddress && <ShippingAddress {...shippingAddress} />}
      <LineItems lineItems={disclosure?.line_items ?? []} />
      <div>{descriptionText}</div>
      <Stack space={spacing.l}>
        <LineItems lineItems={disclosure?.more_info_panel_line_items ?? []} typography="bodyS" />
        <div>{footerText}</div>
      </Stack>
    </Stack>
  )
}

export default DynamicDisclosureLayout
